import { get } from 'svelte/store';

import { currency, exchangeRate } from '../store/currency';
import { locale } from '../store/locale';

export const formatCurrency = (
    price: number,
    digits: boolean = true,
    fromCurrency: string = 'EUR',
    roundUp: boolean = false,
) => {
    const currentCurrency = get(currency);
    const currentLocale = get(locale);
    const chfRate = get(exchangeRate);

    const fromRate = fromCurrency === 'CHF' ? chfRate : 1.0;
    const toRate = currentCurrency === 'CHF' ? chfRate : 1.0;

    const converted = price * (toRate / fromRate);

    const formattedAmount = roundUp
        ? Math.ceil(converted - Number.EPSILON * Math.abs(converted))
        : converted;
    const formatted = new Intl.NumberFormat(currentLocale, {
        style: 'currency',
        currency: currentCurrency,
        maximumFractionDigits: digits ? 2 : 0,
    }).format(formattedAmount);

    return formatted.replace(/\s/g, '');
};
